import {
  CalendarioUtenteGiorno,
  FasceCalendarioUtente,
} from '../../../interfaces/CalendarioUtenteGiorno';
import { UserInterface } from '../../../interfaces/User';
import { formatFasceOrarie } from './FasceOrarieUtils';

/**
 * Utenti in servizio in un giorno, mostrati nella fascia Presenze dell'agenda
 * negozio. Gli orari sono il calendario prenotabile dell'utente nel punto vendita
 * (/api/CalendarUser/GetAll), già incrociato con l'orario del negozio e con
 * straordinari e assenze del giorno.
 */
export interface UtenteInServizio {
  userId: string;
  username: string;
  color: string;
  /** Fasce del giorno come arrivano dal backend (almeno una valida). */
  fasce: FasceCalendarioUtente;
  /** Fasce formattate, es. "09:00-13:00, 15:00-19:00". */
  orario: string;
  /** Inizio della prima fascia valida, 'HH:mm': serve a ordinare per ora d'inizio. */
  inizio: string;
}

// Banda della data richiesta, cercata solo per data esatta: la fascia chiede un
// giorno per volta e un ripiego su un'altra data metterebbe gli orari sul giorno
// sbagliato. GetAll può restituire la data con l'ora ('YYYY-MM-DDT00:00:00').
const getFasceDelGiorno = (
  riga: CalendarioUtenteGiorno,
  giorno: string
): FasceCalendarioUtente | null =>
  riga.calendarList?.find((banda) => banda.date?.slice(0, 10) === giorno)
    ?.hours ?? null;

export const buildInServizio = (
  righe: CalendarioUtenteGiorno[],
  users: Record<string, UserInterface>,
  giorno: string
): UtenteInServizio[] => {
  const inServizio: UtenteInServizio[] = [];
  for (const riga of righe) {
    const user = users[riga.userId];
    const fasce = getFasceDelGiorno(riga, giorno);
    const orario = formatFasceOrarie(fasce);
    // Senza fasce valide l'utente quel giorno non lavora (riposo o assenza).
    if (!user || !fasce || orario === null) continue;
    inServizio.push({
      userId: riga.userId,
      username: user.username,
      color: user.color,
      fasce,
      orario,
      // La prima fascia dell'orario formattato è la prima valida.
      inizio: orario.slice(0, 5),
    });
  }
  return inServizio.sort(
    (a, b) =>
      a.inizio.localeCompare(b.inizio) || a.username.localeCompare(b.username)
  );
};
